import React from 'react';
import { Alert } from 'reactstrap';
import styles from './NotificationMessage.module.scss'
import { useSelector } from 'react-redux';
import { selectNotification } from './notificationMessageSlice';


export function NotificationMessage() {
    const { text, visible, color, onDismiss } = useSelector(selectNotification);

    return (
        <div className={styles.NotificationWrapper}>
            <Alert color={color} isOpen={visible && text !== undefined && text !== ""} toggle={onDismiss}>
                {text}
            </Alert>
        </div>
    );
}